export const Op = {
  and: 'op:and',
  or: 'op:or'
}


export const NodeTypes = {
  condition: 'condition',
  operation: 'operation'
}

export const ConditionOperators = {
  equal: 'equal'
}

export const isOp = (keyName) => {
  return Object.values(Op).indexOf(keyName) !== -1
}

export function getProjectTemplates(project, templates) {
  return templates.filter(({rules}) => {
    function condition(key, value, operator){
      switch(operator){
        case ConditionOperators.equal: {
          return project[key] === value
        }
        default: return false
      }
    }

    function and(arr){
      for(const el of arr){
        if(!mapObject(el)) return false
      }
      return true
    }

    function or(arr) {
      for (const el of arr) {
        if(mapObject(el)) return true
      }
      return false
    }

    function mapObject(obj) {
      if(!obj) return false

      if(obj.type === NodeTypes.operation){
        const {key, value} = obj
        if(!(key && value && Array.isArray(value))) return false

        switch(key){
          case Op.and: {
            return and(value)
          }
          case Op.or: {
            return or(value)
          }
          default: return false;
        }
      } else if(obj.type === NodeTypes.condition){
        const {key, value, operator} = obj
        if(!(key && value && operator)) return false

        return condition(key, value, operator)
      } else {
        return false
      }
    }
    return mapObject(rules)
  })
}

// export function getProjectTemplates(project, templates) {
//   return templates.filter(({condition}) => {
//     function op(key, obj) {
//       if (key === Op.and) {
//         if (and(obj)) return true
//       } else if (key === Op.or) {
//         if (or(obj)) return true
//       }
//
//       return false
//     }
//
//     function and(val) {
//       const mapObject = (obj) => {
//         for (const key of Object.keys(obj)) {
//           if (Object.values(Op).includes(key)) {
//             if (!op(key, obj[key])) return false
//           } else {
//             if (obj[key] !== project[key]) return false
//           }
//         }
//         return true
//       }
//
//       if (Array.isArray(val)) {
//         for (const el of val) {
//           if(!mapObject(el)) return false
//         }
//       } else if (typeof val === 'object') {
//         if(!mapObject(val)) return false
//       } else {
//         return false
//       }
//
//       return true
//     }
//
//     function or(arr) {
//       for (const obj of arr) {
//         if(and(obj)) return true
//       }
//       return false
//     }
//
//     return and(condition)
//   })
// }
